import { Injectable } from '@angular/core';
import { TimelineModel } from '../../models/timeline/timeline.model';
import { BehaviorSubject, Observable, switchMap, tap } from 'rxjs';
import { GlobalComponent } from 'src/app/global-component';
import { MyfileApiService } from '../myfile-api.service';
import { SearchResultModel } from '../../models/query/search-result-model';
import { BaseListService } from './base-list.service';
import { TimelineSearchModel } from '../../models/timeline/timeline-search.model';
import { OwnerEntityType } from '../../enums/owner-entity-type-enum';
import { TimeLineType } from '../../enums/timeline-type-enum';

@Injectable({
  providedIn: 'root'
})
export class TimeLineListService extends BaseListService {

  defaultTimelineListState: TimelineSearchModel = {
    sortColumnDirective: 'modifiedDate',
    sortDirectionDirective: 'desc',
    pageSize: GlobalComponent.defaultPagingInfo.pageSize,
    pageIndex: 0,
    startIndex: 0,
    sortColumn: "",
    sortDirection: "desc",
    searchTerm: "",
  };

  private _resultItems$ = new BehaviorSubject<TimelineModel[]>([]);

  protected override _state: TimelineSearchModel = { ...this.defaultTimelineListState };

  constructor(
    private myFileApiService: MyfileApiService) {
    super();
    this._search$.pipe(
      tap(() => this._loading$.next(true)),
      switchMap(() => this._search()),
      tap(() => this._loading$.next(false))
    ).subscribe((result: any) => {
      this._resultItems$.next(result.items);
      this._total$.next(result.count);
    });
  }

  get resultItems$() { return this._resultItems$.asObservable(); }
  get ownerEntityType() { return this._state.ownerEntityTypes; }
  get ownerId() { return this._state.ownerId; }
  get createdById() { return this._state.createdById; }

  set types(types: TimeLineType[] | undefined) { this._set({ types }) }
  set ownerEntityType(ownerEntityTypes: OwnerEntityType[] | undefined) { this._set({ ownerEntityTypes }) }
  set ownerId(ownerId: string | undefined) { this._setNoSearch({ ownerId }) }
  set name(name: string) { this._set({ name }); }
  set createdById(createdById: string | undefined) { this._set({ createdById }); }

  protected _search(): Observable<SearchResultModel<TimelineModel> | undefined> {

    this.validateStartIndex();

    this._state.sortColumn = this.titleCaseWord(this._state.sortColumnDirective) as string;

    return this.myFileApiService.getTimelinesList(this._state);
  }

  clearListService() {
    this._state = { ...this.defaultTimelineListState };
    this._resultItems$.next(new Array<TimelineModel>());
    this._total$.next(0);
  }

}